export default __webpack_public_path__ + "static/media/partners-background.5cb73c23.svg";